import * as React from 'react';

class FooterComp extends React.Component {
    public render() {
        return (
            <div className="footer">
                <a href="https://m.hzeyun.com/">慧正资讯</a>
                |
                <a href="//m.hzeyun.com/contactUs.html">联系我们</a>
            </div>
        )
    }
}

export default FooterComp;


// WEBPACK FOOTER //
// ./src/components/common/footer.tsx